import { screenGroupResource } from '@/api'

const state = {
  loading: false,
  groups: []
}

const getters = {
  groups: (state) => {
    return state.groups
  }
}

const actions = {
  loadGroups ({ commit }) {
    commit('SET_LOADING', true)

    screenGroupResource.all().then(res => {
      commit('SET_GROUPS', res.data.returnValue)
      commit('SET_LOADING', false)
    }).catch(err => {
      console.log(err)
    })
  },

  addGroup ({ commit }, group) {
    screenGroupResource.create(group).then((res) => {
      commit('ADD_GROUP', res.data.returnValue)
    })
  },

  removeGroup ({ commit }, group) {
    screenGroupResource.destroy(group.screenGroupId).then(() => {
      commit('REMOVE_GROUP', group)
    })
  },

  clearGroups ({ commit }) {
    commit('SET_GROUPS', [])
  }
}

const mutations = {
  SET_LOADING (state, isLoading) {
    state.loading = isLoading
  },

  SET_GROUPS (state, groups) {
    state.groups = groups
  },

  ADD_GROUP (state, group) {
    state.groups.push(group)
  },

  REMOVE_GROUP (state, group) {
    let i = state.groups.map(item => item.screenGroupId).indexOf(group.screenGroupId)
    state.groups.splice(i, 1)
  }
}

export default { namespaced: true, state, getters, actions, mutations }
